import { FC, createContext, useContext, useState, ReactNode } from 'react';

interface ScheduleServiceContextType {
    isLoading: boolean;
    isEditing: boolean;
    isCreating: boolean;
    refreshHistory: boolean;
    userScheduleGroups: any[];
    selectedJob: any;
    setIsLoading: (isLoading: boolean) => void;
    setUserScheduleGroups: (userScheduleGroups: any[]) => void;
    setIsEditing: (isEditing: boolean) => void;
    setIsCreating: (isCreating: boolean) => void;
    setRefreshHistory: (refreshHistory: boolean) => void;
    clearData: () => void;
    setSelectedJob: (newJob: any) => void;
}

const ScheduleServiceContext = createContext<ScheduleServiceContextType | undefined>(undefined);

export const ScheduleServiceProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [isCreating, setIsCreating] = useState<boolean>(false);
    const [refreshHistory, setRefreshHistory] = useState<boolean>(false);
    const [selectedJob, setSelectedJob] = useState<any>({});
    const [userScheduleGroups, setUserScheduleGroups] = useState<any[]>([]);

    const clearData = () => {
        setIsLoading(false);
        setSelectedJob({});
    };

    return (
        <ScheduleServiceContext.Provider
            value={{
                selectedJob,
                setSelectedJob,
                isLoading,
                setIsLoading,
                clearData,
                isEditing,
                setIsEditing,
                setIsCreating,
                isCreating,
                refreshHistory,
                setRefreshHistory,
                userScheduleGroups,
                setUserScheduleGroups,
            }}
        >
            {children}
        </ScheduleServiceContext.Provider>
    );
};

export const useScheduleService = () => {
    const context = useContext(ScheduleServiceContext);
    if (!context) {
        throw new Error('useScheduleService must be used within a ScheduleServiceProvider');
    }
    return context;
};
